import React from 'react';
import {
  TbRulerMeasure,
  TbWeight,
  TbPalette,
  TbShieldCheck,
  TbBox,
  TbTag,
  TbBuildingStore,
  TbClock,
  TbPackage,
} from 'react-icons/tb';

const SpecsTab = ({ product }) => {
  const dimensions = product.dimensions || { width: '---', depth: '---', height: '---' };
  const colors = product.colors || [];

  const specs = [
    {
      icon: TbRulerMeasure,
      label: 'ابعاد',
      value: `${dimensions.width} × ${dimensions.depth} × ${dimensions.height} سانتی‌متر`,
      color: 'from-emerald-400 to-teal-500',
    },
    {
      icon: TbWeight,
      label: 'وزن',
      value: product.weight ? `${product.weight} کیلوگرم` : '---',
      color: 'from-blue-400 to-indigo-500',
    },
    {
      icon: TbPalette,
      label: 'رنگ‌های موجود',
      value: colors.length > 0 ? `${colors.length} رنگ` : 'اطلاعاتی موجود نیست',
      color: 'from-purple-400 to-pink-500',
    },
    {
      icon: TbShieldCheck,
      label: 'گارانتی',
      value: product.guarantee || '---',
      color: 'from-amber-400 to-orange-500',
    },
    {
      icon: TbBox,
      label: 'جنس',
      value: product.material || '---',
      color: 'from-rose-400 to-red-500',
    },
    {
      icon: TbBuildingStore,
      label: 'برند',
      value: product.brand || '---',
      color: 'from-cyan-400 to-sky-500',
    },
  ];

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-[#292524]">مشخصات فنی</h2>
          <p className="text-sm text-[#79716B] mt-1">اطلاعات کامل محصول</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {specs.map((spec, index) => {
          const Icon = spec.icon;
          return (
            <div
              key={index}
              className="group flex items-start gap-4 p-5 rounded-xl bg-white border border-[#D9D9D9]/50 hover:border-[#9EAD8C]/30 hover:shadow-md transition-all duration-300"
            >
              <div
                className={`flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br ${spec.color} flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform duration-300`}
              >
                <Icon className="w-6 h-6" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-xs font-semibold text-[#79716B] uppercase tracking-wider">
                  {spec.label}
                </h3>
                <p className="text-sm font-medium text-[#292524] mt-1 break-words">
                  {spec.value}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      {/* اطلاعات تکمیلی */}
      <div className="p-6 bg-gradient-to-br from-[#F4F1EA] to-[#FDFCFA] rounded-2xl border border-[#D9D9D9]/50">
        <h3 className="font-bold text-[#292524] mb-4 flex items-center gap-2">
          <TbPackage className="w-5 h-5 text-[#9EAD8C]" />
          اطلاعات تکمیلی
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div>
            <p className="text-xs text-[#79716B]">مدل</p>
            <p className="text-sm font-medium text-[#292524]">{product.model || '---'}</p>
          </div>
          <div>
            <p className="text-xs text-[#79716B]">برند</p>
            <p className="text-sm font-medium text-[#292524]">{product.brand || '---'}</p>
          </div>
          <div>
            <p className="text-xs text-[#79716B]">زمان آماده‌سازی</p>
            <p className="text-sm font-medium text-[#292524]">{product.prepTime || '---'}</p>
          </div>
          <div>
            <p className="text-xs text-[#79716B]">موجودی انبار</p>
            <p className="text-sm font-medium text-[#292524]">{product.countInStock || 0} عدد</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecsTab;